/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>PC协议列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
   
      <el-form-item prop="platformType" label="展示平台 ">
    <el-select v-model="formInline.platformType" placeholder="不限">
        <el-option label="不限" value=""></el-option>
      <el-option label="微信小程序" value="1"></el-option>
      <el-option label="抖音小程序" value="2"></el-option>
      <el-option label="PC官网" value="3"></el-option>
      <el-option label="移动官网" value="4"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item prop="type" label="协议类型 ">
    <el-select v-model="formInline.type" placeholder="不限">
        <el-option label="不限" value=""></el-option>
      <el-option label="隐私协议" value="1"></el-option>
      <el-option label="用户协议" value="2"></el-option>
      <el-option label="用户行为规范" value="3"></el-option>
      <el-option label="注销协议" value="4"></el-option>
      <el-option label="个人信息收集清单" value="5"></el-option>


    </el-select>
  </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>



      <div style=" float: right;  ">

        <el-button type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

      </div>
    </el-form>
    <el-table  id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
      @select-all="selectall" @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">

      <el-table-column  prop="id"  align="center" width="300" label="协议id"></el-table-column>
      <el-table-column prop="contentType" align="center" label="展示平台" width="200">
        <template slot-scope="scope">
           <div>{{ scope.row.platformTypeDesc }}</div>
        </template>

      </el-table-column>
      <el-table-column prop="contentType" align="center" label="协议类型" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">隐私协议</span>
          <span v-if="scope.row.type == 2">用户协议</span>
          <span v-if="scope.row.type == 3">用户行为规范</span>
          <span v-if="scope.row.type == 4">注销协议</span>
          <span v-if="scope.row.type == 5">个人信息收集清单</span>
        
        </template>

      </el-table-column>

      <el-table-column prop="closeTime" label="创建时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime | timestampToTime }}</div>

        </template>
      </el-table-column>
       <el-table-column  prop="content"   align="center" label="协议内容">
        <template slot-scope="scope">
        <div style="width: 100%;height: 300px; overflow: hidden;">
          {{ scope.row.content }}
        </div>

        </template>

       </el-table-column>
 

    
      <el-table-column align="center" fixed="right" prop="version" label="操作" width="250">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="primary">编辑</el-button>
          <el-button @click="handleDetele(scope.row.id)" icon="el-icon-delete" type="danger">删除</el-button>
        </template>
      </el-table-column>



    </el-table>




    <el-dialog  :close-on-click-modal="false" :title="title" ref="editForm" center :visible.sync="editFormVisible" width="60%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

   
        <el-form-item prop="type" label="协议类型">
          <el-radio-group v-model="editForm.type">
            <el-radio label="1">隐私协议</el-radio>
            <el-radio label="2">用户协议</el-radio>
            <el-radio label="3">用户行为规范</el-radio>
            <el-radio label="4">注销协议</el-radio>
            <el-radio label="5">个人信息收集清单</el-radio>

            <!-- <span v-if="scope.row.type == 5">个人信息收集清单</span> -->
          </el-radio-group>
        </el-form-item>
  <el-form-item label="展示平台" prop="platformType">
    <el-checkbox-group v-model="editForm.platformType">
    <el-checkbox label="1">微信小程序</el-checkbox>
    <el-checkbox label="2">抖音小程序</el-checkbox>
    <el-checkbox label="3">PC官网</el-checkbox>
    <el-checkbox label="4">移动官网</el-checkbox>
  </el-checkbox-group>
        </el-form-item>

        <el-form-item label="协议详情" prop="content">
          <quill-editor class="editor" v-model="editForm.content" ref="myQuillEditor" :options="editorOption"
            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
          </quill-editor>
        </el-form-item><br>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('editForm ')">取消</el-button>
        <el-button type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="昵称审核" :visible.sync="dialogVisible" width="30%">
      <span>确定是否审核吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="OndialogVisible">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblesss">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  

    <div v-show="false">
      <el-upload class="avatar-uploader" :action=ssoServerimg
        list-type="picture-card" tokenId:this.adder :before-upload="beforeUpload" :on-change="uploadSectionFile"
        :on-success="uploadSuccess" :on-remove="handleRemove">

        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
    <div v-show="false">
      <el-upload class="avatar-uploaders" :action=ssoServerimg
        list-type="picture-card" tokenId:this.adder :before-upload="beforeUpload" :on-change="uploadSectionFile"
        :on-success="uploadSuccessx" :on-remove="handleRemove">

        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
let tokenId = localStorage.getItem('tokenId');
import Vue from 'vue'

import { settingdelete } from '../../api/userMG'


import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
import Quill from "quill";
// Quill.register('modules/quillEmoji', quillEmoji)
let fontFamily = ['Courier New', 'Georgia', 'serif', 'noto', 'Arial',];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import * as imageConversion from 'image-conversion';
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],
  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
  [{ 'direction': 'rtl' }],                         // text direction
  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  [{ font: fontFamily }], // 字体
  [{ 'align': [] }],
  ['link', 'image', 'video'],
  ['clean'],
  ['emoji'],//表情包          
                             // remove formatting button
]

import draggable from 'vuedraggable'
import Axios from 'axios'
import { login } from "../../api"

import { Video } from '../charts/video';
const quill = require('quill');
// import draggable from 'uedraggbale'
quill.register({ 'formats/video': Video }, true);
import Pagination from '../../components/Pagination'
export default {
  // components: {
  //           draggable,
  //       },
  data() {
    return {
      ssoServer:"",
      ssoServerimg:"",
      // dialogVisibleDetail:true,
      dialogVisibleDetail:false,
      editorOption: {
        placeholder: '',
        theme: 'snow',  // or 'bubble'
        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: {
            container: toolbarOptions,  // 工具栏
            handlers: {
              'image': function (value) {
                if (value) {
                  // console.log(value);
                  document.querySelector('.avatar-uploader input').click()
                } else {
                
                  this.quill.format('image', false);
                }
              },
              // 'emoji':function(value){
              //       console.log(value,'1111111111111111');
              // },
              'video': function (value) {
                if (value) {
                  document.querySelector('.avatar-uploaders input').click()
                } else {
                  this.quill.format('video', false);
                }
                // console.log(value);
              },


            }
          }
        }
      },
      dialogImageUrl: '',
      fileList: [],
      dialogImageDetailUrl:[],
      listsss: [],
      Formcover:[],
      dialogVisible: false,
      uploadDisableds:false,
      fileDetailList: [],
      addserss: "",
      tujiaddserss: '',
      dialogVisiblesss: false,
      uploadDisabled: false,
      indexfff: 1,
      indexs: "",
      formInline: {
        type:"",
        platformType:''

      
        // token: localStorage.getItem('logintoken')
      },

      dialogFormVisibleicn: false,
      activeName: '1',
      userlist: "",
      radio: "",
     
      dialogFormVisible: false,
      checkList: [],
      adder: "",
      options123: [],
      undataList: "",
      options1234123: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加协议',

      ifswlimages: [],
      editForm: {
        type:"",
        platformType:[],
        cover:"",
        contentType: "",
        id: "",
        status: "",
        content: [],
        releaseAddress: "",
        platform: "",
        releaseTime: "",
        subTitle: "",
        images: [],
        title: "",
      },

      // rules表单验证
      rules: {
        
        
        type: [
          { required: true, message: '协议类型不能为空', trigger: 'blur' }
        ],
        cover: [
          { required: true, message: '分享图片不能为空', trigger: 'blur' }
        ],
        platformType: [
          { required: true, message: '展示平台不能为空', trigger: 'blur' }
        ],
        
        addDeer: [
          { required: true, message: '请选择位置', trigger: 'blur' }
        ],
        contentType: [{ required: true, message: '图集位置不能为空', trigger: 'blur' }],

        title: [{ required: true, message: '主标题不能为空', trigger: 'blur' }],
        subTitle: [{ required: true, message: '副标题不能为空', trigger: 'blur' }],
        platform: [{ required: true, message: '发布平台不能为空', trigger: 'blur' },
        { min: 0, max: 10, message: '长度在 0 到 10 个字符', trigger: 'blur' }
        ],

        // images: [{ required: true, message: '视频封面不能为空', trigger: 'blur' }],
        releaseTime: [{ required: true, message: '指定发布日期不能为空', trigger: 'blur' }],
        releaseAddress: [{ required: true, message: '发布地址不能为空', trigger: 'blur' },
        { min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur' }
        ],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
        images: [{ required: true, message: '图集封面不能为空', trigger: 'blur' }]




      },

      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
     
    }
  },

  // 注册组件
  components: {
    draggable,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    this.ssoServerimg=Vue.prototype.GLOBAL.ssoServerimg
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId


    // this.getdata(this.formInline)
  },
  mounted() {
    this.formLIst()
 
    



  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleDetele(id){

        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            settingdelete({
                id:id
            }).then(res=>{
                if(res.code==0){
                    this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.formLIst()
                }else{
                    this.$message({
            type: 'warning',
            message: res.message
          });   

                }
            })

       
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });

    },
    handlePictureCardPreviewFileDetail(file) {
     
      this.dialogVisiblesss = true;
 
    this.dialogImageUrl = file;
   
},
// 删除
handleRemoveFileDetail(index,fileList) {
  // console.log(index,item);
  
  this.editForm.images.splice(index, 1);
  this.fileList.splice(index,1)
  console.log(fileList.length);
  if (fileList.length >= 10) {
        this.uploadDisabled = true;
      }else{
        this.uploadDisabled = false;
      }
  // this.uploadDisabled = false;
},


    onEditorBlur() {
    },
    onEditorFocus() {//获得焦点事件
    },
    onEditorChange() {//内容改变事件
      // console.log(this.ruleForm.content);

    },


    uploadSuccess(res, file) {

      console.log(res, file);
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill

      // 如果上传成功
      //  return console.log(res.code);
      if (res.code == '0') {

        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, 'image', res.data)
        // quill.insertEmbed(length, 'video', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        console.log('2222');
        this.$message.error('图片插入失败')
      }
      // loading动画消失
    },
    uploadSuccessx(res, file) {

      console.log(res, file);
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill

      // 如果上传成功
      //  return console.log(res.code);
      if (res.code == '0') {

        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        // quill.insertEmbed(length, 'image', res.data)
        quill.insertEmbed(length, 'video', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        console.log('2222');
        this.$message.error('图片插入失败')
      }
      // loading动画消失
    },





    beforeUpload(file) {
      console.log(file);
      const isLt50M = file.size / 1024 / 1024 < 30;
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 30MB!');
        return
      }
      const _that = this

      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif" || file.type === "video/mp4"||file.type === "video/mov";
      if (file.type == "video/mp4") {
        var isLt2M = file.size / 1024 / 1024 < 30;
      } else {
        var isLt2M = file.size / 1024 / 1024 < 2;
      }

      if (!isJpgOrPng) {
        this.$message.error("上传图片/视频只能是 JPG 或 PNG 或 Mp4格式!");
        return;
      }
      return new Promise((resolve) => {
        // 小于2M 不压缩
        if (isLt2M) {
          resolve(file)
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then((res) => {
          console.log(res);
          resolve(res);
        });
      });
    },
    Onexceed() {
      console.log();
    },


    uploadSectionFile(file, fileList) {
      console.log(fileList);
      if (fileList.length >= 10) {
        this.uploadDisabled = true;
      }
    },
    
    handleAvatarX(res, file){
      this.Formcover=res.data
     
      this.editForm.cover = res.data
          
      if (this.editForm.cover) {
        this.uploadDisableds = true;
      }else{
        this.uploadDisableds = false;
      }
    },
    handleAvatarSuccess(res, file) {
      this.listsss.push(res.data)
      this.editForm.images = this.listsss
          
      if (this.editForm.images.length >= 10) {
        this.uploadDisabled = true;
      }else{
        this.uploadDisabled = false;
      }
    },
    // 删除数据
    deleList() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'success',
          message: '删除的用户不能为空!'
        });
      } else {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      }



    },

    selectallsdss(rows) {
      // console.log("rows : "+JSON.stringify(rows));
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {

        this.$refs.multipleTable.clearSelection();//清除全选
     

      }


    },
    handleRemoveX(file, fileList){
    this.Formcover=[]
    this.editForm.cover=''
    this.uploadDisableds = false;
    },
    handleRemove(file, fileList) {

      this.uploadDisabled = false;
      if (this.indexs == 1) {
        let newfileList = fileList.map((item) => {
          // console.log(item.response.data)  ;
          return item.response.data


        });
        this.editForm.images.push(newfileList)
        this.listsss = newfileList;

      } else if (this.indexs == 2) {

        let newfileLists = fileList.map((item) => {
          return item.url
        });
        this.editForm.images = newfileLists
        this.listsss = newfileLists;

      }



    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblesss = true;
    },
    //添加

    // 确定审核
    OndialogVisible() {

      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-nick-name-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          //   appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '审核成功'
          })
          this.formLIst()
        }
      })





    },
    // 查看历史图片
    historyHeadIcons(item) {
      this.historyHea = item
      // console.log(item);
      this.dialogFormVisibleicn = true

    },
    // 颜值打分
    YZdialogFormVisible() {
      if (!this.radio) {
        this.$message({
          type: 'warning',
          message: '选择不能为空'
        })
        return
      }
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-head-icon-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          appearanceScore: this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: '打分成功'
          })
          this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

    },
    handleCheckedCitiesChange() {
      console.log(this.checkList);
    },
    caozClick() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择要审核的用户'
        })
        return

      } else {
        this.dialogVisible = true
        console.log('1111');
      }

    },

    handleClick(tab, event) {
      //  return  console.log(this.activeName);
      if (this.activeName == 1) {
        this.formInline.status = 1
        this.formLIst()
      } else if (this.activeName == 2) {
        this.formInline.status = 2
        this.formLIst()
      } else if (this.activeName == 3) {
        this.formInline.status = 3
        this.formLIst()
      }

    },

    getAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss() {
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers: {
          tokenId: this.adder
        },

      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    handleEdit(index, row) {
      this.Formcover=[]
   
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
       
        console.log(row);
      
        this.title = '编辑协议'
        this.indexs = 2
        this.editForm.id = row.id
        // this.uploadDisabled = false;
        this.editForm.type = String(row.type)
        // this.editForm.platformType = row.platformType


        let addlist =[]
        row.platformType.forEach(element => {
     addlist.push(String(element))
        });
        this.editForm.platformType=addlist






        this.editForm.content = row.content
        
      } else {
        this.editForm.platformType=[],
        this.editForm.content = ''
        this.editForm.type=''
       
        this.indexs = 1
        this.title = '添加协议'
      
      }
    },

    selectalls(rows) {
      console.log(rows);
      this.userlist = rows
      this.indexs = 2
      if (this.indexs == 2) {
        this.title = '编辑banner'

        let add = String(rows.type)
        let adder=String(rows.platformType)
        //  return  console.log(add);

        this.editFormVisible = true
        this.editForm = this.userlist
        this.editForm.type = add
        this.editForm.platformType=adder
        this.editForm
      }

      // this.undataList =rows

      console.log(rows);
    },

    onChanges(e) {
      // console.log(e);
      this.formInline.releaseAddress = e[1]
      // console.log( this.formInline.registerAddress);
    },
    selectall(val) {
      console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      this.$refs[formInline].resetFields();
    },


    formLIst() {
      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/protocol-setting/list',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        } else if (res.data.code == 500) {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
        this.listData = res.data.data

       
      })

    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {

      this.formInline.current = 1
      this.formLIst()


    },

    submitForm(editForm) {

      this.$refs[editForm].validate((valid) => {
        if (valid) {



          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            if (this.indexs == 1) {
              Axios({
                method: 'post',
                url: this.ssoServer+'/api/protocol-setting/add',
                headers: {
                  tokenId: this.adder
                },
                data: this.editForm
              }).then(res => {
                if (res.data.code == 999) {
                  setTimeout(() => {
                    localStorage.removeItem('tokenId')

                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '登录过期,请重新登录'
                    })
                  }, 1000)
                }
                // return console.log(res.data.code);
                if (res.data.code == 0) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '添加成功'
                  })
                  this.ifswlimages = []
                  this.listsss = []
                  this.Formcover=[]
                  this.formLIst()


                }

              })


            } else {

              Axios({
                method: 'post',
                url: this.ssoServer+'/api/protocol-setting/edit',
                headers: {
                  tokenId: this.adder
                },
                data: this.editForm
              }).then(res => {
                if (res.data.code == 999) {
                  setTimeout(() => {
                    localStorage.removeItem('tokenId')

                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '登录过期,请重新登录'
                    })
                  }, 1000)
                }
                // return console.log(res.data.code);
                if (res.data.code == 0) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  })
                  this.ifswlimages = []
                  this.Formcover=[]
                  // this.editForm.cover=''
                  // this.listsss=[]
                  this.formLIst()
                }

              })




              console.log('编辑');
            }
            loading.close();
          }, 500);




        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(editForm) {
      // this.editForm.cover=''
      this.formLIst()
      // this.Formcover=[]
      // this.formLIst()
      this.ifswlimages = []
      // this.fileList=[]

      // this.$refs[editForm].resetFields();
      this.editFormVisible = false
    }
  }
}
</script>

<style>
.ql-snow .ql-picker.ql-font{
  width: 80px;  
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Arial']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Arial']::before {
  content: 'Arial';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Courier New']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Courier New']::before {
  content: 'Courier New';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Georgia']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Georgia']::before {
  content: 'Georgia';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: 'serif';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='noto']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='noto']::before {
  content: 'noto';
}


.el-upload-list__item {
  transition: none !important;
}

.disabled .el-upload--picture-card {
  display: none !important;
}

.dialogForm {
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .dialogFormChl {
    margin-top: 20px;

    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }

  .dialogFormChl img {
    width: 100%;
    height: 200px;
  }
  
}

.user-search {
  margin-top: 20px;
}


.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/officialWebsite/agreementList.vue